import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../security.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { CustomerProfile } from '../models/customer-profile.model';
import { DataService } from 'src/app/shared/data.service';
import { GenericResponse } from 'src/app/shared/model/generic-response.model';


@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  constructor(
    public dataSvc: DataService, 
    private securitySvc: SecurityService, 
    private router: Router, 
    public dialog:MatDialog, 
    public route: ActivatedRoute) { 

  }

  buttonSelected: string="Login";
  verificationCode: String="";
  prof = new CustomerProfile();
  navigateTo: String= "/login";
  ret: GenericResponse;

  popMsg = {
    'title':'',
    'message':''
  }


  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.prof.loginId = params['loginId'];});
  }

  verifyCodeAndResetPassword(){
    if (!this.isFormComplete()) return;

    this.prof.emailVerificationCode = this.verificationCode;
    this.securitySvc.resetPassword(this.prof).subscribe(
      res => {
        console.log("Response for reset password: " + JSON.stringify(res));
        console.log("Reset password - NavigateTo: " + this.navigateTo);
        this.ret = res;
        if(this.ret.ret == -1){
          this.popMsg.title="Reset password failed";
          this.popMsg.message="Reset password failed. Please try again"
          this.openDialog(this.popMsg);
          return;          
        }

        console.log("Verification  : " + res);
        this.popMsg.title="Success!";
        this.popMsg.message="Reset password was successful."
        this.openDialog(this.popMsg);
         
        this.router.navigate([this.navigateTo]);
      },
      err => {
        this.popMsg.title="Reset password failed";
        this.popMsg.message="Reset password failed, please try again"
        console.log(err)
        this.openDialog(this.popMsg);
        return;

      })
  }

  isFormComplete() :boolean{
    if (this.verificationCode === ''){
      this.popMsg.title = 'Verification Code Needed';
      this.popMsg.message = 'Please enter the verification code you received in the email';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.prof.password === ''){
      this.popMsg.title = 'Incomplete Registration Form';
      this.popMsg.message = 'Please enter the password';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.prof.confirmPassword === ''){
      this.popMsg.title = 'Incomplete Registration Form';
      this.popMsg.message = 'Please confirm the password';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.prof.password !== this.prof.confirmPassword){
      this.popMsg.title = 'Incomplete Registration Form';
      this.popMsg.message = 'Passwords don\'t match. Please correct.';

      this.openDialog(this.popMsg);
      return false;
    }
    return true;
  }


  resendVerificationCode(){
    this.securitySvc.resendEmailVerificationCode(this.prof).subscribe(
      res => {
        this.popMsg.title="Email verification code sent";
        this.popMsg.message="Resent the email verification code, please check your email."
        this.openDialog(this.popMsg);
        return;
      },
      err => {
        this.popMsg.title="Email verification code resend failed";
        this.popMsg.message="Email verification code resend failed, please try again"
        console.log(err)
        this.openDialog(this.popMsg);
        return;

      })



  }


  openDialog(popupMessage){
    this.dialog.open(DialogWithCloseButtonComponent, {data: popupMessage});
  } 


}
